import { Injectable } from '@angular/core';
import { ProductConnector } from '@b2b/features/product/core/services/product.connector';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import {
  getProductList,
  setProductListFail,
  setProductListSuccess,
} from '@b2b/features/product/core/store/actions/product-list.actions';

@Injectable()
export class ProductListEffects {
  constructor(
    private actions: Actions,
    private productListConnector: ProductConnector,
  ) {}

  getProductList$ = createEffect(() => {
    return this.actions.pipe(
      ofType(getProductList),
      mergeMap(({ params }) => {
        return this.productListConnector.getProducts(params).pipe(
          map(productList => {
            if (productList.hasError) {
              return setProductListFail({ erroMessage: productList.message || '' });
            }

            return setProductListSuccess({ data: productList });
          }),
        );
      }),
    );
  });
}
